import React from 'react';
import { MenuItem, Nav, Navbar, NavDropdown, NavItem } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import store from '../../store/store';
import { tryToLogout } from '../../store/session.store';
import RoleConfigFilter, {
  getAllPositionBookTypeConfigs,
  hasOnlyRoles,
  ReportName,
  validateRoleConfig,
  isResponsibleForAnySupplyDemand } from '../auth/RoleConfigFilter.jsx';
import AvailableSince, { VERSIONS } from '@/util/version';
import { dealsTypeSwitch, useMobileVersion } from '@/store/allaround.store';
import Notifications from '../notifications/Notifications';
import Changelog from '../changelog/Changelog';
import GlobalSearchField from '../blogic/deals/search/GlobalSearchField';
import { navTo } from '../../util/util';
import './header.less';
import profile from '@/../style/profile.png';

const mapStateToProps = state => ({
  saving: state.getIn(['allaround', 'saving'], false),
  firstName: state.getIn(['session', 'firstName']),
  lastName: state.getIn(['session', 'lastName']),
  user: state.getIn(['session', 'user']),
  roles: state.getIn(['session', 'roles'], ''),
  useMobileVersion: state.getIn(['allaround', 'useMobileVersion'], true),
});

const mapDispatchToProps = dispatch => ({
  onLogoutClick: () => {
    tryToLogout(dispatch);
  },
  dealsTypeSwitch() {
    dealsTypeSwitch(dispatch);
  },
  useMobileVersionSwitch(value) {
    useMobileVersion(dispatch, value);
  },
});

class HeaderClass extends React.Component {
  constructor(args) {
    super(args);
    this.onNavigateUsers = this.onNavigate.bind(this, '/management/users');
    this.onNavigateRoles = this.onNavigate.bind(this, '/management/roles');
    this.onNavigateInterestRate = this.onNavigate.bind(this, '/management/interestrate');
    this.onNavigateSystemCurrencies = this.onNavigate.bind(this, '/management/systemcurrencies');
    this.onNavigateBugReports = this.onNavigate.bind(this, '/management/bugreports');
    this.onNavigatePacking = this.onNavigate.bind(this, '/references/packing');
    this.onNavigatePort = this.onNavigate.bind(this, '/references/port');
    this.onNavigateDeliveryTerm = this.onNavigate.bind(this, '/references/deliveryterm');
    this.onNavigateOrigin = this.onNavigate.bind(this, '/references/origin');
    this.onNavigatePaymentMethod = this.onNavigate.bind(this, '/references/paymentmethod');
    this.onNavigateSupplier = this.onNavigate.bind(this, '/references/supplier');
    this.onNavigateSpecification = this.onNavigate.bind(this, '/references/specification');
    this.onNavigateProduct = this.onNavigate.bind(this, '/references/product');
    this.onNavigateProfile = this.onNavigate.bind(this, '/profile');
    this.onNavigateBuyer = this.onNavigate.bind(this, '/references/buyer/');
    this.onNavigateCalendar = this.onNavigate.bind(this, '/calendar');
    this.onNavigateExpensesType = this.onNavigate.bind(this, '/references/expensestype');
    this.onNavigateExpensesCategory = this.onNavigate.bind(this, '/references/expensecategory');
    this.onNavigateForwarder = this.onNavigate.bind(this, '/references/forwarder');
    this.onNavigateShippingLine = this.onNavigate.bind(this, '/references/shippingline');
    this.onNavigateTopManager = this.onNavigate.bind(this, '/references/topmanager');
    this.onNavigateCurrencyLine = this.onNavigate.bind(this, '/references/currency');
    this.onNavigateOwner = this.onNavigate.bind(this, '/references/owner');
    this.onNavigateVesselBroker = this.onNavigate.bind(this, '/references/vesselbroker');
    this.onNavigateLoadingTerm = this.onNavigate.bind(this, '/references/loadingterm');
    this.onNavigateBank = this.onNavigate.bind(this, '/references/bank');
    this.onNavigateProducer = this.onNavigate.bind(this, '/references/producer');
    this.onNavigateDocumentType = this.onNavigate.bind(this, '/references/documenttype');
    this.onNavigateRegion = this.onNavigate.bind(this, '/references/region');
    this.onNavigatePortGroup = this.onNavigate.bind(this, '/references/portgroup');
    this.onNavigateCommonCounterparties =
      this.onNavigate.bind(this, '/references/commoncounterparties');
    this.onNavigateTradeCounterparties =
      this.onNavigate.bind(this, '/references/tradecounterparty');
    this.onNavigateInsuranceCompany = this.onNavigate.bind(this, '/references/insurancecompany');
    this.onNavigateInspectionCompany = this.onNavigate.bind(this, '/references/inspectioncompany');
    this.onNavigatePurchase = this.onNavigateDeals.bind(this, 'purchase');
    this.onNavigateTransport = this.onNavigateDeals.bind(this, 'transport');
    this.onNavigateSale = this.onNavigateDeals.bind(this, 'sale');
    this.onNavigateUnlinked = this.onNavigateDeals.bind(this, 'unlinked');
    this.onNavigateInPayments = this.onNavigateDeals.bind(this, 'inpayments');
    this.onNavigateOutPayments = this.onNavigateDeals.bind(this, 'outpayments');
    this.onNavigateClosedPayments = this.onNavigateDeals.bind(this, 'closedpayments');
    this.onNavigateTodayPayments = this.onNavigateReports.bind(this, 'todaysPayments');
    this.onNavigatePositionMap = this.onNavigateReports.bind(this, 'positionmap');
    this.onNavigatePositionBook = this.onNavigateReports.bind(this, 'positionbook');
    this.onNavigateOpenPosition = this.onNavigateReports.bind(this, 'openposition');
    this.onNavigateCounterpartyOutstanding =
      this.onNavigateDeals.bind(this, 'counterpartyoutstanding');
    this.onNavigateUnifiedDeals = this.onNavigateReports.bind(this, 'customreports');
    this.onNavigatePaymentsReport = this.onNavigateReports.bind(this, 'payments');
    this.onNavigateCommonPayments = this.onNavigateDeals.bind(this, 'commonpayments');
    this.onNavigateProfitabilityReports = this.onNavigateReports.bind(this, 'profitability');
    this.onNavigateVolumeReports = this.onNavigateReports.bind(this, 'volumereport');
    this.onNavigatePerformanceReport = this.onNavigateReports.bind(this, 'performance');
    this.onNavigateAnalyticsReport = this.onNavigateReports.bind(this, 'analytics');
    this.onNavigateUserPerformance = this.onNavigateReports.bind(this, 'userperformance');
    this.onNavigateSupplyDemandReport = this.onNavigateReports.bind(this, 'supplyDemand');
    this.onNavigateMultinodalReport = this.onNavigateReports.bind(this, 'multinodal');
    this.onNavigateEarningStatementReport = this.onNavigateReports.bind(this, 'earningStatements');
    this.onNavigateHome = this.onNavigate.bind(this, '/');
    this.onNavigateReindex = this.onNavigate.bind(this, '/management/reindex');
    this.onNavigatePrices = this.onNavigate.bind(this, '/management/pricesdb');
    this.onNavigateCutoff = this.onNavigate.bind(this, '/management/cutoff');
    this.onLogout = this.onLogout.bind(this);
    this.onMobileSwitch = this.onMobileSwitch.bind(this);
  }

  onLogout() {
    if (!this.props.saving) {
      this.props.onLogoutClick();
      store.dispatch(replace('/auth'));
    }
  }

  onNavigate(url) {
    if (!this.props.saving) {
      navTo(url, true);
    }
  }

  onNavigateDeals(dealType) {
    this.props.dealsTypeSwitch();
    this.onNavigate(`/deals/${dealType}`);
  }

  onNavigateReports(report) {
    this.onNavigate(`/reports/${report}`);
  }

  onMobileSwitch() {
    if (!this.props.saving) {
      this.props.useMobileVersionSwitch(!this.props.useMobileVersion);
    }
  }

  render() {
    const fullName = (this.props.firstName == null && this.props.lastName == null)
      ? this.props.user :
      `${this.props.firstName ? this.props.firstName : ''}
      ${this.props.lastName ? this.props.lastName : ''}`;
    const roles = this.props.roles;
    return (
      <Navbar fixedTop>
        <Navbar.Header>
          <img
            // eslint-disable-next-line
            src="/extlogo.png" onError={e => { e.target.onerror = null; e.target.src = '/logo.png'; }}
            alt="ERP"
            style={{ float: 'Left', height: '60px', padding: '10px' }}
            onClick={this.onNavigateHome}
          />
          <Navbar.Toggle />
        </Navbar.Header>
        {this.props.loginScreen ? '' :
          <div>
            <Navbar.Collapse
              className={`navbar-collapse ${this.props.secondNavBar ? '' : 'single-line-navbar'}`}
            >
              <div className={'first-nav-bar'}>
                <RoleConfigFilter
                  permissions={['allDeals#1', 'myDeals#1', 'allTransports#1',
                    'myTransports#1', 'viewDealsByRegion']}
                >
                  <Navbar.Form
                    id="dealSearch" pullLeft className="dealSearch"
                  >
                    <GlobalSearchField />
                  </Navbar.Form>
                </RoleConfigFilter>
                <Nav pullLeft className="navbar-deals-menu">
                  {hasOnlyRoles(['ROLE_FINANCE']) ?
                    <div />
                    :
                    <RoleConfigFilter
                      permissions={['allDeals#1', 'myDeals#1', 'allTransports#1',
                        'myTransports#1', 'viewDealsByRegion']}
                    >
                      <NavDropdown
                        pullLeft
                        disabled={this.props.saving}
                        eventKey={1} title="Deals" id="deals"
                      >
                        {!this.props.saving && [
                          <RoleConfigFilter
                            permissions={['allDeals#1', 'myDeals#1', 'viewDealsByRegion']}
                          >
                            <MenuItem
                              id="dealDropdownPurchase"
                              eventKey={1.1} onClick={this.onNavigatePurchase}
                            >Purchase
                            </MenuItem>
                          </RoleConfigFilter>,
                          <RoleConfigFilter
                            permissions={['allTransports#1', 'myTransports#1']}
                          >
                            <MenuItem
                              id="dealDropdownTransport"
                              eventKey={1.2} onClick={this.onNavigateTransport}
                            >Transport
                            </MenuItem>
                          </RoleConfigFilter>,
                          <RoleConfigFilter
                            permissions={['allDeals#1', 'myDeals#1', 'viewDealsByRegion']}
                          >
                            <MenuItem
                              id="dealDropdownSale"
                              eventKey={1.3} onClick={this.onNavigateSale}
                            >Sale
                            </MenuItem>
                          </RoleConfigFilter>,
                          <RoleConfigFilter
                            permissions={['allDeals#1', 'myDeals#1', 'viewDealsByRegion']}
                          >
                            <MenuItem
                              id="dealDropdownUnlinked"
                              eventKey={1.4} onClick={this.onNavigateUnlinked}
                            >P & S
                            </MenuItem>
                          </RoleConfigFilter>]
                        }
                      </NavDropdown>
                    </RoleConfigFilter>
                  }
                  <RoleConfigFilter
                    permissions={['financesViewEditDelete', 'myPaymentsView', 'viewPayments']}
                  >
                    <AvailableSince version={VERSIONS.IphitoFinal}>
                      <NavDropdown
                        pullLeft
                        disabled={this.props.saving}
                        eventKey={1} title="Payments" id="payments"
                      >
                        {!this.props.saving && [
                          <NavItem
                            id="dealDropdownOutPayments"
                            href="#"
                            onClick={this.onNavigateOutPayments}
                          >
                          Outgoing payments
                          </NavItem>,
                          <NavItem
                            pullLeft
                            id="dealDropdownInPayments"
                            href="#"
                            onClick={this.onNavigateInPayments}
                          >
                          Incoming payments
                          </NavItem>,
                          <NavItem
                            id="dealDropdownCommonPayments"
                            href="#"
                            onClick={this.onNavigateCommonPayments}
                          >
                          Common payments
                          </NavItem>,
                          <NavItem
                            id="dealDropdownClosedPayments"
                            href="#"
                            onClick={this.onNavigateClosedPayments}
                          >
                          Closed payments
                          </NavItem>,
                          validateRoleConfig(['financesViewEditDelete']) ?
                            <NavItem
                              id="dealDropdownCounterpartyOutstanding"
                              href="#"
                              onClick={this.onNavigateCounterpartyOutstanding}
                            >
                            Counterparty outstanding
                            </NavItem>
                            :
                            '']
                        }
                      </NavDropdown>
                    </AvailableSince>
                  </RoleConfigFilter>
                  <AvailableSince version={VERSIONS.Kleoptoleme}>
                    <NavDropdown
                      pullLeft
                      disabled={this.props.saving}
                      eventKey={1.5} title="Reports" id="reports"
                    >
                      {!this.props.saving && [
                        <RoleConfigFilter
                          reportPermissions={[ReportName.OPEN_POSITION]}
                          permissions={['management', 'viewReports']}
                        >
                          <MenuItem
                            id="openPositionReport"
                            eventKey={1.54} onClick={this.onNavigateOpenPosition}
                          >Overview
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          reportPermissions={[ReportName.POSITION_MAP]}
                          permissions={['management', 'viewReports']}
                        >
                          <MenuItem
                            id="dealUnlinkedPortRegions"
                            eventKey={1.52} onClick={this.onNavigatePositionMap}
                          >Position map
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          reportPermissions={[ReportName.POSITION_BOOK,
                            ...getAllPositionBookTypeConfigs()]}
                          permissions={['management', 'viewReports']}
                        >
                          <MenuItem
                            id="dealPositionBook"
                            eventKey={1.53} onClick={this.onNavigatePositionBook}
                          >Position book
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          reportPermissions={[ReportName.PROFITABILITY]}
                          permissions={['management', 'viewReports']}
                        >
                          <MenuItem
                            id="profitabilityReports"
                            eventKey={1.54} onClick={this.onNavigateProfitabilityReports}
                          >Profitability
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          reportPermissions={[ReportName.VOLUME]}
                          permissions={['management', 'viewReports']}
                        >
                          <MenuItem
                            id="volumeReports"
                            eventKey={1.54} onClick={this.onNavigateVolumeReports}
                          >Volume
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          reportPermissions={[ReportName.PAYMENTS]}
                          permissions={['management', 'viewReports']}
                        >
                          <MenuItem
                            id="paymentsReport"
                            eventKey={1.55} onClick={this.onNavigatePaymentsReport}
                          >Payments
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          reportPermissions={[ReportName.CUSTOM_REPORTS,
                            ReportName.CUSTOM_REPORTS_REGIONAL]}
                          permissions={['management']}
                        >
                          <MenuItem
                            id="unifiedDeals"
                            eventKey={1.56} onClick={this.onNavigateUnifiedDeals}
                          >Custom reports
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          reportPermissions={[ReportName.PERFORMANCE]}
                          permissions={['management', 'viewReports']}
                        >
                          <MenuItem
                            id="performanceReport"
                            eventKey={1.57} onClick={this.onNavigatePerformanceReport}
                          >Performance
                          </MenuItem>
                        </RoleConfigFilter>,
                        isResponsibleForAnySupplyDemand() ?
                          <MenuItem
                            id="supplyDemand"
                            eventKey={1.59} onClick={this.onNavigateSupplyDemandReport}
                          >Supply/Demand
                          </MenuItem>
                          :
                          <RoleConfigFilter
                            reportPermissions={[ReportName.SUPPLY_DEMAND]}
                            permissions={['management', 'viewReports']}
                          >
                            <MenuItem
                              id="supplyDemand"
                              eventKey={1.59} onClick={this.onNavigateSupplyDemandReport}
                            >Supply/Demand
                            </MenuItem>
                          </RoleConfigFilter>,
                        <RoleConfigFilter
                          reportPermissions={[ReportName.ANALYTICS]}
                          permissions={['management', 'viewReports']}
                        >
                          <MenuItem
                            id="analyticsReport"
                            eventKey={1.58} onClick={this.onNavigateAnalyticsReport}
                          >Analytics
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          reportPermissions={[ReportName.USER_PERFORMANCE]}
                          permissions={['management', 'viewReports']}
                        >
                          <MenuItem
                            id="dealDropdownTodayPayments"
                            eventKey={1.51} onClick={this.onNavigateUserPerformance}
                          >User performance
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          reportPermissions={[ReportName.MULTINODAL]}
                          permissions={['management', 'viewReports']}
                        >
                          <MenuItem
                            id="dealDropdownMultiNodal"
                            eventKey={1.51} onClick={this.onNavigateMultinodalReport}
                          >Multi-nodal
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          reportPermissions={[ReportName.EARNING_STATEMENTS]}
                          permissions={['management', 'viewReports']}
                        >
                          <MenuItem
                            id="dealDropdownEarningStatementNodal"
                            eventKey={1.51} onClick={this.onNavigateEarningStatementReport}
                          >Earning statement
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          reportPermissions={[ReportName.TODAYS_PAYMENTS]}
                          permissions={['management', 'viewReports', 'financesViewEditDelete']}
                        >
                          <MenuItem
                            id="dealDropdownTodayPayments"
                            eventKey={1.51} onClick={this.onNavigateTodayPayments}
                          >Todays payments
                          </MenuItem>
                        </RoleConfigFilter>]
                      }
                    </NavDropdown>
                  </AvailableSince>
                </Nav>
                <Nav pullRight className={'navbar-right main-navbar-right'}>
                  <RoleConfigFilter
                    permissions={['references#2', 'viewReferences']}
                  >
                    <NavDropdown
                      disabled={this.props.saving}
                      className="navbar-references-menu"
                      eventKey={2} title="References" id="references"
                    >
                      {!this.props.saving && [
                        <MenuItem
                          id="bank"
                          onClick={this.onNavigateBank}
                        >
                        Banks
                        </MenuItem>,
                        <MenuItem
                          id="buyer"
                          onClick={this.onNavigateBuyer}
                        >
                        Buyers
                        </MenuItem>,
                        <AvailableSince version={VERSIONS.Mimnousa}>
                          <MenuItem
                            id="currencyLine"
                            onClick={this.onNavigateCurrencyLine}
                          >
                          Currency rates
                          </MenuItem>
                        </AvailableSince>,
                        <MenuItem
                          id="deliveryterm"
                          onClick={this.onNavigateDeliveryTerm}
                        >
                        Delivery terms
                        </MenuItem>,
                        <MenuItem
                          id="documenttype"
                          onClick={this.onNavigateDocumentType}
                        >
                        Document types
                        </MenuItem>,
                        <MenuItem
                          id="expensecategory"
                          onClick={this.onNavigateExpensesCategory}
                        >
                        Expense categories
                        </MenuItem>,
                        <MenuItem
                          id="expensestype"
                          onClick={this.onNavigateExpensesType}
                        >
                        Expenses
                        </MenuItem>,
                        <MenuItem
                          id="forwarder"
                          onClick={this.onNavigateForwarder}
                        >
                        Forwarders
                        </MenuItem>,
                        <MenuItem
                          id="inspectioncompany"
                          onClick={this.onNavigateInspectionCompany}
                        >
                        Inspection companies
                        </MenuItem>,
                        <MenuItem
                          id="insurancecompany"
                          onClick={this.onNavigateInsuranceCompany}
                        >
                        Insurance companies
                        </MenuItem>,
                        <MenuItem
                          id="laytimeterm"
                          onClick={this.onNavigateLoadingTerm}
                        >
                        Laytime terms
                        </MenuItem>,
                        <MenuItem
                          id="origin"
                          onClick={this.onNavigateOrigin}
                        >
                        Origins/Destinations
                        </MenuItem>,
                        <MenuItem
                          id="packing"
                          onClick={this.onNavigatePacking}
                        >
                        Packings
                        </MenuItem>,
                        <MenuItem
                          id="paymentmethod"
                          onClick={this.onNavigatePaymentMethod}
                        >
                        Payment methods
                        </MenuItem>,
                        <MenuItem
                          id="port"
                          onClick={this.onNavigatePort}
                        >
                        Ports
                        </MenuItem>,
                        <MenuItem
                          id="portGroup"
                          onClick={this.onNavigatePortGroup}
                        >
                        Port groups
                        </MenuItem>,
                        <MenuItem
                          id="producer"
                          onClick={this.onNavigateProducer}
                        >
                        Producers
                        </MenuItem>,
                        <MenuItem
                          id="product"
                          onClick={this.onNavigateProduct}
                        >
                        Products
                        </MenuItem>,
                        <MenuItem
                          id="region"
                          onClick={this.onNavigateRegion}
                        >
                        Regions
                        </MenuItem>,
                        <MenuItem
                          id="seller"
                          onClick={this.onNavigateSupplier}
                        >
                        Sellers
                        </MenuItem>,
                        <MenuItem
                          id="owner"
                          onClick={this.onNavigateOwner}
                        >
                        Ship owners
                        </MenuItem>,
                        <MenuItem
                          id="vesselbroker"
                          onClick={this.onNavigateVesselBroker}
                        >
                        Ship brokers
                        </MenuItem>,
                        <MenuItem
                          id="shippingline"
                          onClick={this.onNavigateShippingLine}
                        >
                        Shipping lines
                        </MenuItem>,
                        <MenuItem
                          id="topmanager"
                          onClick={this.onNavigateTopManager}
                        >
                        Top managers
                        </MenuItem>,
                        <MenuItem
                          id="tradecounterparty"
                          onClick={this.onNavigateTradeCounterparties}
                        >
                        Trade counterparties
                        </MenuItem>]
                      }
                    </NavDropdown>
                  </RoleConfigFilter>
                  <RoleConfigFilter
                    roles={['ROLE_ADMIN']}
                    permissions={['userManagement']}
                  >
                    <NavDropdown
                      disabled={this.props.saving}
                      className="navbar-admin-menu"
                      eventKey={3} title="Administration" id="administration"
                    >
                      {!this.props.saving && [
                        <RoleConfigFilter
                          permissions={['userManagement']}
                        >
                          <MenuItem id="users" eventKey={3.1} onClick={this.onNavigateUsers}>
                          User management
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          roles={['ROLE_ADMIN']}
                        >
                          <MenuItem
                            id="interestRate"
                            eventKey={3.3}
                            onClick={this.onNavigateInterestRate}
                          >
                          Interest rate
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          roles={['ROLE_ADMIN']}
                        >
                          <MenuItem id="roles" eventKey={3.4} onClick={this.onNavigateRoles}>
                          Roles management
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          roles={['ROLE_ADMIN']}
                        >
                          <MenuItem
                            id="bugreports"
                            eventKey={3.5}
                            onClick={this.onNavigateBugReports}
                          >
                          Bug Reports management
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          roles={['ROLE_ADMIN']}
                        >
                          <MenuItem
                            id="pricesdatabase"
                            eventKey={3.6}
                            onClick={this.onNavigatePrices}
                          >
                          External databases
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          roles={['ROLE_ADMIN']}
                        >
                          <MenuItem id="dealscutoff" eventKey={3.7} onClick={this.onNavigateCutoff}>
                          Deals cut off date
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          roles={['ROLE_ADMIN']}
                        >
                          <MenuItem
                            id="systemCurrencies"
                            eventKey={3.8}
                            onClick={this.onNavigateSystemCurrencies}
                          >
                          System currencies
                          </MenuItem>
                        </RoleConfigFilter>,
                        <RoleConfigFilter
                          roles={['ROLE_ADMIN']}
                        >
                          <MenuItem id="reindex" eventKey={3.9} onClick={this.onNavigateReindex}>
                          Reindex database
                          </MenuItem>
                        </RoleConfigFilter>]
                      }
                    </NavDropdown>
                  </RoleConfigFilter>
                  <AvailableSince version={VERSIONS.Sometime}>
                    <NavItem
                      id="calendarLink" eventKey={4} href="#" onClick={this.onNavigateCalendar}
                    > Calendar
                    </NavItem>
                  </AvailableSince>
                  {roles && roles.split(',').filter(r => r != 'ROLE_TRADER'
                    && r != 'ROLE_TRADER_HEAD')
                    .length > 0 ?
                    <NavItem
                      disabled={this.props.saving}
                      id="notifications"
                      eventKey={7}
                      className="navbar-notifications"
                    >
                      <Notifications />
                    </NavItem>
                    :
                    ''
                  }
                  <NavItem
                    className="navbar-changelog"
                    id="changelog"
                  >
                    <Changelog />
                  </NavItem>
                  <NavItem
                    className="mobile-switch" id="mobile-switch"
                    href="#" onClick={this.onMobileSwitch}
                  >
                    {this.props.useMobileVersion ?
                      'Switch to full version' : 'Switch to mobile version'}
                  </NavItem>
                  <NavItem
                    disabled={this.props.saving}
                    id="userInfo" eventKey={5} href="#" onClick={this.onNavigateProfile}
                  >
                    <img src={profile} alt={'profile'} className={'profile-icon'} /> {fullName}
                  </NavItem>
                  <NavItem
                    id="logout"
                    href="#"
                    disabled={this.props.saving}
                    onClick={this.onLogout}
                  >Logout</NavItem>
                </Nav>
              </div>
              {this.props.secondNavBar ? this.props.secondNavBar : ''}
            </Navbar.Collapse>
          </div>
        }
      </Navbar>);
  }
}

HeaderClass.propTypes = {
  firstName: React.PropTypes.string,
  lastName: React.PropTypes.string,
  user: React.PropTypes.string,
  onLogoutClick: React.PropTypes.func,
  roles: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.object]),
  loginScreen: React.PropTypes.bool,
  secondNavBar: React.PropTypes.object,
  dealsTypeSwitch: React.PropTypes.func,
  useMobileVersionSwitch: React.PropTypes.func,
  useMobileVersion: React.PropTypes.bool,
  saving: React.PropTypes.bool,
};
export const Header = connect(mapStateToProps, mapDispatchToProps)(withRouter(HeaderClass));
